import { createLucideIcon } from 'lucide-react';
export const PlusIcon = createLucideIcon('foobar', [
  [
    'path',
    {
      d: 'M12 20V11.619V4',
      key: '1jfw5j',
    },
  ],
  [
    'path',
    {
      d: 'M20 12H11.619L4 12',
      key: '1iymy0',
    },
  ],
]);
